import styled from 'styled-components';
import Icon from '../../../components/Icon';

export const StyledEmojiPickerTrigger = styled.button`
  display: flex;
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[5]};
  box-shadow: ${(p) => p.theme.shadows.all};
  border-radius: ${(p) => p.theme.radii.pill};
  user-select: none;

  &:disabled {
    opacity: 0.5;
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusOuter};
  }
`;

export const StyledArrowDownIcon = styled(Icon).attrs({
  name: 'arrow-down',
})``;

export const StyledEmojiIcon = styled.span`
  margin-right: ${(p) => p.theme.space[2]};
`;
